<lib-prod-grid
  [title]="prodGridTitle"
  [icon]="'dataset'"
  [columns]="prodGridColumns"
  [isAddButtonShown]="true"
  [isAddButtonDisabled]="isAddButtonDisabled"
  [isEditButtonShown]="true"
  [isRemoveButtonShown]="true"
  [isRemoveButtonDisabled]="isRemoveButtonDisabled"
  [matTableDataSource]="matTableDataSource"
  [inputAction$]="inputAction$"
  (outputAction$)="outputActionEvents($event)"></lib-prod-grid>
